import { MacBrand } from '@/components/MacBrand';
import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const names = {entities:"Legal entities", accounts:"Chart of accounts", periods:"Fiscal periods",
  journals:"Journal entries", cash_facts:"Cash evidence", document_storage:"Private document storage",
  malware_scanner:"Document scanning", mac_receiver:<><MacBrand /> connection</>};
const reasons = {RECORDS_REQUIRED:"Supporting records needed", READ_UNAVAILABLE:"Could not verify records",
  CONFIGURATION_REQUIRED:"Configuration needed"};

export default function OperationalReadiness() {
  const [data,setData] = useState(null);
  const [error,setError] = useState("");
  const [retry,setRetry] = useState(0);
  useEffect(()=>{
    const controller=new AbortController();let live=true;
    setData(null);setError("");
    api.get('/operations/readiness',{signal:controller.signal})
      .then(({data:result})=>{
        if(!result?.observed_at || !Array.isArray(result.blockers))throw new Error("Invalid readiness response");
        if(live)setData(result);
      })
      .catch(e=>{if(live&&e.code!=='ERR_CANCELED')setError(formatApiError(e.response?.data?.detail,"Readiness could not be checked."));});
    return()=>{live=false;controller.abort();};
  },[retry]);
  return <aside className="ops-onboarding" aria-label="Financial readiness">
    <h3>Financial readiness</h3>
    {error ? <p role="alert">{error} <button className="ops-text-button" onClick={()=>setRetry(n=>n+1)}>Retry readiness</button></p>
    : !data ? <p role="status">Checking your records…</p>
    : <><p>Observed {new Date(data.observed_at).toLocaleString()}. Full production acceptance remains to be verified.</p>
      {data.blockers.length ? <ul>{data.blockers.map(item=><li key={item.key}>{names[item.key]||item.key}: {reasons[item.reason]||item.reason}</li>)}</ul>
      : <p>The initial review identified no missing records or configuration items. Operational workflow and recovery still require independent verification.</p>}
      <p>Income-tax preparation belongs in Steward &amp; Stone. JMH brings its financial summaries and obligations into your enterprise overview.</p>
    </>}
  </aside>;
}
